<button mat-button (click)="goBack()" ><i class="fa fa-caret-square-left"></i><span>Back</span></button>
<button mat-button (click)="importData()" ><mat-icon>cloud_upload</mat-icon><span>Import</span></button>
<button mat-button (click)="deleteList()" ><mat-icon>delete_forever</mat-icon><span>Delete</span></button>
